/* eslint-disable no-nested-ternary */ const arraySumReducer = (sum, n)=>sum + n;
export const arraySum = (numArray)=>numArray.reduce(arraySumReducer, 0);
export const bankersRound = (number, precision = 0)=>{
    const x = number * 10 ** precision;
    const r = Math.round(x);
    const br = Math.abs(x) % 1 === 0.5 ? r % 2 === 0 ? r : r - 1 : r;
    return br / 10 ** precision;
};
